module.exports = __webpack_public_path__ + "img/gtzy1_zhTc.109e15e2.png";